import { Permission } from '@/api';
import { BaseModal } from '@/components/base-modal';
import { useErrorNotification } from '@/hooks/use-error-notification';
import { useHasPermissions } from '@/hooks/use-has-permissions';
import { useNotification } from '@/hooks/use-notification';
import { useTriggerAutoCalc } from '@/pages/queries';
import { Text } from '@lego/klik-ui';
import type { RefObject } from 'react';

type RunAutoCalcModalProps = {
  isOpen: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  onClose: () => void;
};

const RunAutoCalcModal = ({
  isOpen,
  triggerRef,
  onClose,
}: RunAutoCalcModalProps) => {
  const hasPermission = useHasPermissions([Permission.ManageLelPrices]);
  const showNotification = useNotification();
  const showErrorNotification = useErrorNotification();
  const { mutate: runAutoCalc, isPending } = useTriggerAutoCalc(
    () => {
      showNotification({
        title: 'AutoCalc started',
        description:
          'Local prices are being recalculated. This can take a few minutes.',
        type: 'success',
      });
      onClose();
    },
    (error) => showErrorNotification(error, 'start AutoCalc'),
  );
  return (
    <BaseModal
      isOpen={isOpen}
      triggerRef={triggerRef}
      onClose={onClose}
      title="Run AutoCalc?"
      rightButtonProps={{
        text: 'Run AutoCalc',
        onClick: () => runAutoCalc(),
        loading: isPending,
        disabled: !hasPermission,
      }}
    >
      <Text className="body-md-medium">
        This will recalculate local prices for all price lists with AutoCalc
        enabled, for this year and next year.
      </Text>
    </BaseModal>
  );
};
export default RunAutoCalcModal;
